export const useVideoLinkPreview = (url: string) => {
  const runtimeConfig = useRuntimeConfig()
  const { linkKey } = runtimeConfig.public
  const encodedUrl = encodeURIComponent(url)

  return `https://iframe.ly/api/iframely?api_key=${linkKey}&url=${encodedUrl}`
}
